import React from "react";

export default function AddJersey({
  jerseyNumber,
  userAthlete,
  loading,
  onJerseyNumberChange,
  onJerseyNumberUpdate,
  loadingPositionDrills,
  onGrantPositionDrills,
  onRemovePositionDrills,
}) {
  return (
    <div className="flex items-center gap-4 mb-4">
      <input
        type="text"
        value={jerseyNumber}
        onChange={onJerseyNumberChange}
        placeholder={
          !userAthlete.jerseyNumber ||
          userAthlete.jerseyNumber.trim() === "" ||
          userAthlete.jerseyNumber === "null"
            ? "Add jersey number"
            : userAthlete.jerseyNumber
        }
        className="border rounded-md p-2"
      />

      <button
        onClick={onJerseyNumberUpdate}
        className={`rounded-md p-2 ${loading ? "bg-[#5057FF]/50 cursor-not-allowed" : "bg-[#5057FF]"} text-white`}
        disabled={loading}
      >
        {loading ? "Adding..." : "Add"}
      </button>

      {!userAthlete.hasPositionDrills && (
        <button
          onClick={onGrantPositionDrills}
          className={`rounded-md p-2 ${loadingPositionDrills ? "bg-[#5057FF]/50 cursor-not-allowed" : "bg-[#5057FF]"} text-white`}
          disabled={loadingPositionDrills}
        >
          {loadingPositionDrills ? "Giving..." : "Give Position Drills"}
        </button>
      )}

      {userAthlete.hasPositionDrills &&
        userAthlete.positionDrillGrantedByAdmin && (
          <button
            onClick={onRemovePositionDrills}
            className={`rounded-md p-2 ${loadingPositionDrills ? "bg-red-600/50 cursor-not-allowed" : "bg-red-600"} text-white`}
            disabled={loadingPositionDrills}
          >
            {loadingPositionDrills ? "Removing..." : "Remove Position Drills"}
          </button>
        )}
    </div>
  );
}
